module.exports = __webpack_public_path__ + "img/8_uk.b1cc23ea.svg";